import jsonLogic from 'json-logic-js';
export const applyConstraints = (attributes, constraints, values) => {
    const newAttributes = Object.keys(attributes).reduce((accAtributes, attributeKey) => {
        const attribute = attributes[attributeKey];
        const constraint = constraints[attributeKey];
        if (!constraint) {
            return {
                ...accAtributes,
                [attributeKey]: attribute
            };
        }
        const jsonLogicValues = jsonLogic.apply(constraint, values);
        if (jsonLogicValues.includes(null)) {
            return accAtributes;
        }
        const newAttribute = jsonLogicValues
            .filter((logicValue) => logicValue !== false)
            .reduce((currentAttribute, logicValue) => {
            const parsed = JSON.parse(logicValue);
            return {
                ...currentAttribute,
                ...parsed
            };
        }, attribute);
        return {
            ...accAtributes,
            [attributeKey]: newAttribute
        };
    }, {});
    return newAttributes;
};
//# sourceMappingURL=apply-constraints.js.map